export default __webpack_public_path__ + "static/me-5bfd33112766aa906fd1258e66d0abfb.jpeg";